import { mapState, mapMutations, mapActions } from "vuex";
export default {
    computed: {
        ...mapState("updateload", [])
    },
    methods: {
        ...mapMutations("updateload", ["setKey"]),
        ...mapActions("updateload", ["getKey"])
    },
}